import React from "react";
import PropTypes from "prop-types";
import MenuCloseIcon from "./header/menu-close-icon";
import Logo from "./logo";
import HeaderContent from "./header/header-content";
import NavigationBar from "./header/navigation-bar";

const DashboardHeader = ({ open, availableLocales, locale, onLocaleChange, url, onDrawerOpen, logoUrl, logoAlt }) => (
  <NavigationBar open={open}>
    <MenuCloseIcon onClick={onDrawerOpen} open={open} />
    <Logo url={url} logoUrl={logoUrl} logoAlt={logoAlt} />
    <HeaderContent availableLocales={availableLocales} locale={locale} onLocaleChange={onLocaleChange} />
  </NavigationBar>
);

DashboardHeader.propTypes = {
  /**
   * Url del enlace del logo
   **/
  url: PropTypes.string,
  /**
   * Indica si el menú lateral del dashboard está desplegado
   **/
  open: PropTypes.bool,
  /**
   * Lista de locales disponibles
   **/
  availableLocales: PropTypes.arrayOf(PropTypes.string).isRequired,
  /**
   * Locale configurado para el usuario
   **/
  locale: PropTypes.string.isRequired,
  /**
   * Handler que se llama al seleccionar un locale del menú de locales
   **/
  onLocaleChange: PropTypes.func.isRequired,
  /**
   * Handler que se llama al clicar el botón de desplegar o cerrar el dashboard
   **/
  onDrawerOpen: PropTypes.func,
  /**
   * Url de la imagen del logo
   **/
  logoUrl: PropTypes.string,
  /**
   * Texto alternativo de la imagen del logo
   **/
  logoAlt: PropTypes.string,
};

export default DashboardHeader;
